"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGolfLinkedLineUrl = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getGolfLinkedLineUrl = (item, order_id) => {
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    const config = latest_version.config;
    return `/orders/${order_id}/transfer?date=${dayjs(config.where_when_who.date).format("YYYY-MM-DD")}${config.where_when_who.region_id &&
        `&region_id=${encodeURIComponent(config.where_when_who.region_id)}&linked_line_id=${encodeURIComponent(item.id)}&number_of_passengers=${encodeURIComponent(config.where_when_who.number_of_golfers)}&to_area=${encodeURIComponent(config.course.id)}&to_name=${encodeURIComponent(config.course.name.en)}&to_type=Course&from_area=${encodeURIComponent(config.course.id)}&from_name=${encodeURIComponent(config.course.name.en)}&from_type=Course`}`;
};
exports.getGolfLinkedLineUrl = getGolfLinkedLineUrl;
